import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    Typography,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React, { useEffect } from 'react';
import { CustomLabel, Loadable,DependentsList } from '../../../../common';
import CloseIcon from '@mui/icons-material/Close';

const useStyles = makeStyles(theme => ({
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
}));

function DependencyDialog(props) {
    const { open, serviceId, codeServiceDependencies, codeServiceDependencyPending, codeServiceDeletePending, serviceName,
        handleRefresh, actions: { setCodeServiceDependencyDialog, getCodeServiceDependencies, deleteService } } = props;

    const classes = useStyles();

    useEffect(() => {
        if (open && serviceId) {
            getCodeServiceDependencies(serviceId)
        }
    }, [open, serviceId, getCodeServiceDependencies]);

    const handleDialogClose = () => {
        setCodeServiceDependencyDialog(null);
    }

    const handleDeleteCallback = () => {
        setCodeServiceDependencyDialog(null);
        handleRefresh(true);
    }

    const handleDelete = () => {
        if (codeServiceDependencies.length > 0) return
        deleteService(serviceId, handleDeleteCallback);
    }

    return (
        (<Dialog maxWidth='sm' fullWidth open={open} onClose={handleDialogClose}>
            <Loadable loading={codeServiceDependencyPending || codeServiceDeletePending}>
                <DialogTitle>
                    <Grid container>
                        <Grid item xs={11}>
                            <Typography variant="h6">
                                Dependencies ({serviceName})
                            </Typography>
                        </Grid>
                        <Grid item xs={1}>
                            <IconButton
                                aria-label="close"
                                className={classes.closeButton}
                                onClick={handleDialogClose}
                                size="large">
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    </Grid>

                </DialogTitle>
                <DialogContent dividers>
                    <Grid>
                        {codeServiceDependencies?.records?.length > 0 ? (
                            <Typography>
                                {codeServiceDependencies?.canDelete
                                    ? "Following Dependencies are Found"
                                    : "Can not delete this code service. Please delete all the dependencies first"}
                            </Typography>
                        ) : (
                            <Typography>
                                No dependency found. Please click to delete
                            </Typography>
                        )}
                    </Grid>
                  
                    <DependentsList dependents={codeServiceDependencies?.records} isSimpleDependency={true}/>
                    
                </DialogContent>
                <DialogActions className='p-4'>
                    <Button variant="contained" onClick={handleDialogClose}>
                        Cancel
                    </Button>
                    <Button
                        onClick={handleDelete}
                        variant="contained"
                        disabled={codeServiceDependencyPending || codeServiceDeletePending || !codeServiceDependencies?.canDelete}
                        color="primary"
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Loadable >
        </Dialog>)
    );
}

export default DependencyDialog
